import {
  Context,
  useUserOrderFactory,
  UseUserOrderFactoryParams
} from '@vue-storefront/core';
import type { Order } from '@bee-hole/api';
import type {
  useUserOrderSearchParams as SearchParams
} from '../types';
import { useApiError } from '../useApiError';

const params: UseUserOrderFactoryParams<Order, SearchParams> = {
  provide: () => ({
    useApiError: useApiError()
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  searchOrders: async (context: Context, params) => {
    const res = await context.$xbuy.api.orderList(params);
    if (res.code > 0) {
      context.useApiError.set(res);
    }
    return res.data;
  }
};

export const useUserOrder = useUserOrderFactory<Order, SearchParams>(params);
